import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import React from "react";

import { ReturnedToSenderIA } from "./instantAnswersComponents/orders/ReturnedToSenderIA";

export const returnedToSender: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => RETURNED_TO_SENDER_TITLE(strictLocalize),
    getDescription: () => RETURNED_TO_SENDER_DESCRIPTION(),
  };
};

const RETURNED_TO_SENDER_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Returned to sender",
    description: {
      text: "Title for the instant answer about a package being returned to sender",
    },
  });

const RETURNED_TO_SENDER_DESCRIPTION = () => {
  return <ReturnedToSenderIA />;
};
